'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _propTypes2 = _interopRequireDefault(_propTypes);
require('./Menu.css');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

/**
 * Item within a menu
 */
var MenuItem = function (_Component) {
  _inherits(MenuItem, _Component);
  function MenuItem() {
    var _ref;
    var _temp, _this, _ret;
    _classCallCheck(this, MenuItem);
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = MenuItem.__proto__ || Object.getPrototypeOf(MenuItem)).call.apply(_ref, [this].concat(args))), _this), _this.focus = function () {
      _this.refs['a'].focus();
    }, _this.render = function () {
      var _this$props = _this.props,
        href = _this$props.href,
        onClick = _this$props.onClick,
        children = _this$props.children,
        rest = _objectWithoutProperties(_this$props, ['href', 'onClick', 'children']);
      return _react2.default.createElement('a', _extends({}, rest, {
        className: 'c-menu__item',
        href: href,
        onClick: onClick,
        ref: 'a'
      }), _react2.default.createElement('div', {
        className: 'c-menu__label'
      }, children));
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }
  /**
   * Sets focus to this menu item
   */

  return MenuItem;
}(_react.Component);
MenuItem.propTypes = process.env.NODE_ENV !== "production" ? {
  /** Specifies the URL of the link */
  href: _propTypes2.default.string,
  /** onClick event function*/
  onClick: _propTypes2.default.func,
  /** Content to display as the menu item */
  children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]).isRequired
} : {};
exports.default = MenuItem;